import { initWebComponents as originalInitWebComponents } from '@fnc-common/loader'
import { appendGoogleIframe, appendGoogleTagScript } from '../utils/googleAnalytics'

export const initWebComponents = async configuration => {
  const manifest = await (await fetch(new URL('./manifest.json', import.meta.url))).json()

  const registry = await originalInitWebComponents({
    ...manifest,
    ...configuration
  })

  // Google Analytics
  appendGoogleIframe(manifest.gtmAuth, manifest.gtmPreview)
  appendGoogleTagScript(manifest.gtmAuth, manifest.gtmPreview)

  registry.ready()
  return registry
}
